export const DEFAULT_ADMIN_MARKUP = 20;

export interface AdminPricingFields {
  international: boolean;
  markup: number;
}

export const normalizeAdminPricing = (
  international?: boolean | null,
  markup?: number | null,
): AdminPricingFields => ({
  international: Boolean(international),
  markup:
    typeof markup === "number" && !Number.isNaN(markup)
      ? markup
      : DEFAULT_ADMIN_MARKUP,
});

export const getAdminPricingPayload = (
  international: unknown,
  markup: unknown,
): AdminPricingFields => ({
  international: Boolean(international),
  markup:
    typeof markup === "number" && Number.isFinite(markup) && markup >= 0
      ? markup
      : DEFAULT_ADMIN_MARKUP,
});
